import React from "react";
import { Link } from "react-router-dom";

const InfoSection = () => {
  // const info = [
  //   "Guests traveling with Birth Certificates will experience significantly longer embarkation and debarkation.",
  //   "If you unexpectedly need to depart the ship from a foreign port prior to the end of sailing, a passport would be required to travel internationally by air.",
  //   "International ports of call can change their travel requirements at their sole discretion and may unexpectedly require all guests to have a valid passport to go ashore.",
  //   "For all international guests, please have all your travel documents and visa if needed before the sailing if needed",
  // ];
  return (
    <div>
      <h4 className="font-semibold text-mv-darkblue text-lg mb-4">
        Each member of your sailing party is required to bring current, valid
        and accepted forms of travel documentation to check-in for your sailing
        at each departure port. No photocopies, photographs or digital copies
        are ever permitted. Entering in your travel documentation above is to
        assist port terminal agents confirm documentation during check-in and is
        not a valid substitute for bringing your documents with you at the Port.
      </h4>
      <div className="font-bold">
        Margaritaville at Sea highly recommends that all guests travel with a
        passport valid for at least six months after your return date.
      </div>
      <p>
        For more information, please see our{" "}
        <Link
          className="text-blue-600 font-semibold hover:underline"
          target="_blank"
          to="https://margaritavilleatsea.com/resort-at-sea/travel-requirements"
        >
          Travel Requirements
        </Link>{" "}
      </p>
    </div>
  );
};

export default InfoSection;
